module.exports = __webpack_public_path__ + "24e004ab/img/print-icon.d8dbbca5.svg";